module.exports = __webpack_public_path__ + "img/separator.d7c5e7cb.svg";